import { FC, useState } from 'react';
import { Modal } from 'src/components/UI/Modal';
import { UIButton } from 'src/components/UI/UIButton';
import { ConnectTelegramToAgentModalSettings } from 'src/types/modal';
import { UIInput } from '../UI/UIInput.tsx';
import { useSetModal } from 'src/providers/ModalsProvider.tsx';

const STEPS = [
  {
    title: 'Open Telegram',
    description: 'Start a chat with @BotFather',
  },
  {
    title: 'Create a Bot',
    description:
      'Send /newbot, name your bot, and set a username ending in bot (e.g., MyAIHelper_bot)',
  },
  {
    title: 'Get Token',
    description: 'Copy the token provided by @BotFather',
  },
  {
    title: 'Connect',
    description:
      'Paste the token into the Telegram section on the Customization page and click Submit',
  },
  {
    title: 'Add to Groups',
    description:
      'Once connected, add the bot to your groups as an admin to enable it to perform its tasks',
  },
];

export const ConnectTelegramToAgentModal: FC<ConnectTelegramToAgentModalSettings> = ({
  onConnect,
  onDisconnect,
  token,
  isSuccess,
}) => {
  const [currentToken, setCurrentToken] = useState<string>('');
  const setModal = useSetModal();

  if (isSuccess) {
    return (
      <Modal>
        <div className="modal-title">Telegram successfully connected!</div>
        <UIInput
          disabled
          containerClasses="pt-0 pb-0 mb-8"
          label="Token"
          value={token!}
          name="telegram-token"
          onChange={() => {}}
        />
        <div className="mb-4 flex gap-2">
          <UIButton buttonColor="gray" disabled={!token} className="w-full" onClick={onDisconnect}>
            Disconnect
          </UIButton>
          <UIButton disabled={!token} className="w-full" onClick={() => setModal(null)}>
            Ok
          </UIButton>
        </div>
      </Modal>
    );
  }

  return (
    <Modal>
      <div className="modal-title">Connecting Telegram</div>
      <div className="mb-6 flex flex-col gap-6">
        {STEPS.map((step, i) => (
          <div key={i} className="flex items-start justify-start gap-3 text-white">
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-[#3C3E40]">
              <p className="text-lg">{i + 1}</p>
            </div>
            <div className="flex flex-col">
              <p className="text-lg">{step.title}</p>
              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>

      <UIInput
        containerClasses="pt-0 pb-0 mb-8"
        label="Insert Token"
        placeholder="Token"
        value={currentToken}
        name="telegram-token"
        onChange={(e) => setCurrentToken(e.target.value)}
      />

      <UIButton
        disabled={!currentToken}
        className="mb-4 w-full"
        onClick={() => onConnect?.(currentToken)}
      >
        Connect
      </UIButton>
    </Modal>
  );
};
